 <template>
   <div class="left">
    <background-anim></background-anim>
    <div class="left-inner">
      <div class="left-bg">
        <div class="botui-app-container" id="my-botui-app">
          <bot-ui></bot-ui>
        </div>
      </div>
    </div>
  </div>
</template>

<style type="text/css">
  .left {
    box-shadow: 5px 0 5px -5px rgba(0,0,0,.5);
    color: #efefef;
    background: #2980b9; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2980b9, #2c3e50); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2980b9, #2c3e50); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */ 
    width: 50%;
    height: 100%;
    float: left;
    text-align: center;
    overflow: hidden;
    position: fixed;
  }
  .left-bg {
    margin: 50px auto;
    transform: translateZ(20px);
    background: url('../assets/iphone2.png') no-repeat;
    background-size: cover;
    display: block;
    width: 320px;
    height: 600px;
    text-align: center;
  }
  @media screen and (max-width: 1000px) {
    .left {
      display: block;
      width: 100%;
      position: relative;
    }
    .left-bg {
      margin: 0 auto;
      height: 450px;
      position: relative;
      top: 25px;
      text-align: center;
    }
  }
  #my-botui-app {
    position: relative;
    width: 280px;
    top: 50px;
  }
  #my-botui-app .botui-container {
    margin-top: 50px;
    background-color: transparent;
  }
  #my-botui-app .botui-container::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
  #my-botui-app .botui-actions-container {
    text-align: right;
  }
  .botui-message {
    text-align: left;
  }
  #my-botui-app .botui-actions-buttons-button {
    box-shadow: none;
    border-radius: 25px;
  }
  .botui-actions-buttons-button:focus {
    outline: none;
  }
  #my-botui-app .botui-message-content.human {
    background: #2f80ed; /* fallback for old browsers */
  }
  @media screen and (max-width: 1000px) {
    #my-botui-app .botui-container {
      height: 350px;
    }
  }

</style>

<script type="text/javascript">

  import VanillaTilt from 'vanilla-tilt';
  import BackgroundAnim from './sections/BackgroundAnim';

  export default {
    name: 'left',
    components: {
      VanillaTilt,
      BackgroundAnim,
    },
    methods: {
      startTilt() {
        VanillaTilt.init(document.querySelector('.left-inner'), {
          max: 25,
          speed: 400,
        });
      },
    },
    mounted() {
      this.startTilt();
    },
  };
</script>


// WEBPACK FOOTER //
// Left.vue?4d1906c5